import _Map from "@babel/runtime-corejs3/core-js/map";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import { onMounted, onUnmounted, provide, inject, useInstance } from 'intact-vue-next';
var RECORD_COMPONENT = 'RecordComponent';
export function useRecordParent(key, useMap) {
  if (key === void 0) {
    key = RECORD_COMPONENT;
  }
  if (useMap === void 0) {
    useMap = false;
  }
  var items = useMap ? new _Map() : [];
  provide(key, items);
  return items;
}
export function useRecordItem(key, item, value) {
  if (key === void 0) {
    key = RECORD_COMPONENT;
  }
  if (item === void 0) {
    item = useInstance();
  }
  var items = inject(key);
  if (items) {
    onMounted(function () {
      if (value === undefined) {
        items.push(item);
      } else {
        items.set(item, value);
      }
    });
    onUnmounted(function () {
      if (value === undefined) {
        _spliceInstanceProperty(items).call(items, items.indexOf(item), 1);
      } else {
        items.delete(item);
      }
    });
  }
  return items;
}